import { render, staticRenderFns } from "./goLive.vue?vue&type=template&id=d487aa98&scoped=true"
import script from "./goLive.vue?vue&type=script&lang=js"
export * from "./goLive.vue?vue&type=script&lang=js"
import style0 from "./goLive.vue?vue&type=style&index=0&id=d487aa98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d487aa98",
  null
  
)

export default component.exports